import {
  EmbedBankIntegrationRedirectPaths,
  getBankIntegrationPageURL,
  getDashboardPageUrl
} from '@root/constants'
import { getAbsoluteUrl } from './getAbsoluteUrl'
import { getMobileAwarePath } from './getMobileAwarePath'

export const getRequisitionRedirectURL = (
  isEmbedded: boolean,
  slug: string,
  embeddedRedirectUrl: string | null,
  embeddedErrorRedirectUrl: string | null
): { redirectUrl: string; errorRedirectUrl: string } => {
  const basicErrorRedirectUrl = getAbsoluteUrl(
    getMobileAwarePath(getDashboardPageUrl(slug), isEmbedded)
  )
  const basicRedirectUrl = getAbsoluteUrl(
    getMobileAwarePath(getBankIntegrationPageURL(slug, 'finalize'), isEmbedded)
  )
  const failureRedirectUrl = getAbsoluteUrl(
    getMobileAwarePath(getBankIntegrationPageURL(slug, 'failed'), isEmbedded)
  )

  const redirectUrl =
    isEmbedded && embeddedRedirectUrl
      ? `${embeddedRedirectUrl}/${EmbedBankIntegrationRedirectPaths.ENABLE}`
      : basicRedirectUrl

  // Embedded mobile keeps its own error return. The web app shows the failure slide.
  let errorRedirectUrl = failureRedirectUrl
  if (isEmbedded && embeddedErrorRedirectUrl) {
    errorRedirectUrl = `${embeddedErrorRedirectUrl}/${EmbedBankIntegrationRedirectPaths.ENABLE}`
  } else if (isEmbedded) {
    errorRedirectUrl = basicErrorRedirectUrl
  }

  return { redirectUrl, errorRedirectUrl }
}
